import React, { useState } from 'react';
import axios from 'axios';
import { TextField, Button, Box, Typography, CircularProgress } from '@mui/material';

const CNPJSearch: React.FC = () => {
  const [cnpj, setCnpj] = useState('');
  const [data, setData] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = async () => {
    if (!cnpj) {
      setError('Por favor, insira um CNPJ válido');
      return;
    }

    setError('');
    setLoading(true);
    try {
      const response = await axios.get(`https://receitaws.com.br/v1/cnpj/${cnpj}`);
      setData(response.data);
    } catch (error) {
      setError('Erro ao buscar dados. Verifique o CNPJ e tente novamente.');
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  const renderField = (key: string, value: any) => {
    if (Array.isArray(value)) {
      return (
        <Box key={key} sx={{ mt: 2 }}>
          <Typography variant="h6">{key}:</Typography>
          {value.map((item, index) => (
            <Box key={index} sx={{ ml: 2 }}>
              {Object.entries(item).map(([subKey, subValue]) => (
                <Typography key={subKey}>
                  {subKey}: {String(subValue)}
                </Typography>
              ))}
            </Box>
          ))}
        </Box>
      );
    } else if (typeof value === 'object' && value !== null) {
      return (
        <Box key={key} sx={{ mt: 2 }}>
          <Typography variant="h6">{key}:</Typography>
          <Box sx={{ ml: 2 }}>
            {Object.entries(value).map(([subKey, subValue]) => (
              <Typography key={subKey}>
                {subKey}: {String(subValue)}
              </Typography>
            ))}
          </Box>
        </Box>
      );
    } else {
      return (
        <Typography key={key}>
          {key}: {String(value)}
        </Typography>
      );
    }
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" p={2}>
      <Typography variant="h4" gutterBottom>
        Consulta de CNPJ
      </Typography>
      <TextField
        label="Digite o CNPJ"
        variant="outlined"
        value={cnpj}
        onChange={(e) => setCnpj(e.target.value)}
        fullWidth
        margin="normal"
      />
      <Button variant="contained" color="primary" onClick={handleSearch} disabled={loading}>
        Buscar
      </Button>
      {loading && <CircularProgress sx={{ mt: 2 }} />}
      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
      {data && (
        <Box mt={4} p={2} border="1px solid #ccc" borderRadius={4} width="100%">
          {Object.entries(data).map(([key, value]) => renderField(key, value))}
        </Box>
      )}
    </Box>
  );
};

export default CNPJSearch;
